import { NotificationEnum } from "@graphql/generated/graphql.g";

import { getNotificationTypeLabel } from "@utils/notificationTypes";

type Props = {
  notificationType: NotificationEnum;
};

export const NotificationTypeMappingText = ({ notificationType }: Props) => {
  return getNotificationTypeLabel(notificationType);
};
